import { pushEvent } from '../../client/data-layer';

export const trackProductRecommendationClicked = (
  contextId: string,
  productId: number,
  recommender: string
) => {
  pushEvent('productRecommendationClicked', {
    context_id: contextId,
    product_id: productId,
    recommender,
  });
};
